import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { ReactComponent as Rectangle } from "../../../../assets/previewPage/Rectangle 41943.svg";
import { ReactComponent as Line } from "../../../../assets/previewPage/Line.svg";
import { ReactComponent as ContactIcon } from "../../../../assets/MainPage/addBlock/countDown/call.svg";
import { ReactComponent as Whatsapp } from "../../../../assets/MainPage/addBlock/countDown/whatsapp.svg";
import { ReactComponent as HeaderShareIcon } from "../../../../assets/previewPage/headerIcons/headershareicon.svg";
import { ReactComponent as ShareIcon } from "../../../../assets/previewPage/headerIcons/PaperPlaneTilt.svg";
import { ReactComponent as LanguageShareIcon } from "../../../../assets/previewPage/headerIcons/grommet-icons_language.svg";

// import "../../cards/GlobalHeadingStyles.css"; // Import the global heading styles
const baseUrl = process.env.REACT_APP_API_URL;

const HeaderTextStickyCard = ({ item, styles, isSticky }) => {
  const [coloumValue, setColoumValue] = useState(null);
  const [stylesColoumValue, setStylesColoumValue] = useState(null);

  useEffect(() => {
    if (item?.coloum_value) {
      try {
        const parsedColoumValue = JSON.parse(item.coloum_value);
        setColoumValue(parsedColoumValue);
        if (parsedColoumValue?.avatar_outline) {
          const parsedStylesColoumValue = JSON.parse(
            parsedColoumValue.avatar_outline
          );
          setStylesColoumValue(parsedStylesColoumValue);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, [item]);

  // const applyClassesToHtml = (html) => {
  //   if (!html) return '';
  //   // Regular expression to match opening <h1>, <h2>, <h3>, <h4>, <h5>, <h6> tags
  //   const regex = /<h([1-6])[^>]*>/g;

  //   // Replace all opening <hX> tags with the corresponding class
  //   const updatedHtml = html.replace(
  //     regex,
  //     (match, capturedGroup) =>
  //       `<h${capturedGroup} class='custom-h${capturedGroup.toLowerCase()}'>`
  //   );

  //   return updatedHtml;
  // };

  const alignmentClass =
    coloumValue?.alignment === "left"
      ? "items-start"
      : coloumValue?.alignment === "right"
      ? "items-end"
      : "items-center";

  const justifyClass =
    coloumValue?.alignment === "left"
      ? "justify-start"
      : coloumValue?.alignment === "right"
      ? "justify-end"
      : "justify-center";

  const backgroundImageUrl = coloumValue?.backGroundImage
    ? baseUrl + "/profile/" + coloumValue?.backGroundImage
    : "";

  const calculateMarginTop = (size) => {
    switch (size) {
      case "75x75":
        return "mt-[36px]";
      case "100x100":
        return "mt-[48px]";
      case "125x125":
        return "mt-[59px]";
      case "150x150":
        return "mt-[70px]";
      default:
        return "mt-[36px]";
    }
  };

  const marginTopClass = calculateMarginTop(coloumValue?.avatar_size);

  const calculateTop = (size) => {
    switch (size) {
      case "75x75":
        return "top-[102px]";
      case "100x100":
        return "top-[88px]";
      case "125x125":
        return "top-[74px]";
      case "150x150":
        return "top-[60px]";
      default:
        return "top-[102px]";
    }
  };

  const TopClass = calculateTop(coloumValue?.avatar_size);

  const truncateTitle = (title) => {
    if (title?.length > 20) {
      return title.slice(0, 20) + "...";
    }
    return title;
  };

  return (
    <div className={`flex flex-col w-full md:w-[303px]`}>
      {backgroundImageUrl ? (
        <div
          className={`flex bg-cover bg-center bg-no-repeat w-full h-[80px] object-cover relative`}
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
          }}
        >
          <div
            className={`flex items-center flex-grow  px-[20px]`}
            style={{
              margin: "0 auto",
            }}
          >
            <div className="flex justify-start items-center gap-[8px] smm:gap-[16px] flex-grow">
              <img
                style={{
                  borderStyle: stylesColoumValue?.outline_style,
                  borderColor: stylesColoumValue?.outline_colour,
                  gap: "0px",
                  opacity: "0px",
                }}
                className={`object-cover max-h-[46px] min-h-[46px] h-[46px] max-w-[46px] min-w-[46px] w-[46px] ${
                  coloumValue?.avatar_shape
                    ? coloumValue?.avatar_shape === "rounded"
                      ? "rounded-lg"
                      : coloumValue?.avatar_shape === "circle"
                      ? "rounded-full"
                      : "rounded-none"
                    : coloumValue?.avatar_shape === "rounded"
                    ? "rounded-lg"
                    : coloumValue?.avatar_shape === "circle"
                    ? "rounded-full"
                    : "rounded-none"
                } ${
                  stylesColoumValue
                    ? `${
                        stylesColoumValue?.outline_width === "8px"
                          ? "border-8"
                          : stylesColoumValue?.outline_width === "4px"
                          ? "border-4"
                          : stylesColoumValue?.outline_width === "2px"
                          ? "border-2"
                          : "border"
                      } border-${stylesColoumValue?.outline_style} border-[${
                        stylesColoumValue?.outline_colour
                      }]`
                    : ""
                }`}
                src={`${
                  coloumValue?.image
                    ? baseUrl + "/profile/" + coloumValue?.image
                    : ""
                }`}
                alt="avatar"
                title="Avatar"
              />
              <h1 className={`text-white text-body_copy2`}>
                {truncateTitle(coloumValue?.pageName)}
              </h1>
            </div>
            <div className="flex justify-end">
              <HeaderShareIcon
                className="cursor-pointer"
                style={{
                  width: "16px",
                  height: "16px",
                  gap: "0px",
                  opacity: "0px",
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`flex  w-full md:w-[303px] h-[80px] relative`}
          style={{ background: "#294776" }}
        >
          <div
            className={`flex items-center flex-grow  px-[20px]`}
            style={{
              margin: "0 auto",
            }}
          >
            <div className="flex justify-start items-center gap-[8px] smm:gap-[16px] flex-grow">
              <img
                style={{
                  borderStyle: stylesColoumValue?.outline_style,
                  borderColor: stylesColoumValue?.outline_colour,
                  gap: "0px",
                  opacity: "0px",
                }}
                className={`object-cover max-h-[46px] min-h-[46px] h-[46px] max-w-[46px] min-w-[46px] w-[46px]  ${
                  coloumValue?.avatar_shape
                    ? coloumValue?.avatar_shape === "rounded"
                      ? "rounded-lg"
                      : coloumValue?.avatar_shape === "circle"
                      ? "rounded-full"
                      : "rounded-none"
                    : coloumValue?.avatar_shape === "rounded"
                    ? "rounded-lg"
                    : coloumValue?.avatar_shape === "circle"
                    ? "rounded-full"
                    : "rounded-none"
                } ${
                  stylesColoumValue
                    ? `${
                        stylesColoumValue?.outline_width === "8px"
                          ? "border-8"
                          : stylesColoumValue?.outline_width === "4px"
                          ? "border-4"
                          : stylesColoumValue?.outline_width === "2px"
                          ? "border-2"
                          : "border"
                      } border-${stylesColoumValue?.outline_style} border-[${
                        stylesColoumValue?.outline_colour
                      }]`
                    : ""
                }`}
                src={`${
                  coloumValue?.image
                    ? baseUrl + "/profile/" + coloumValue?.image
                    : ""
                }`}
                alt="avatar"
                title="Avatar"
              />
              <h1 className={`text-white text-body_copy2`}>
                {truncateTitle(coloumValue?.pageName)}
              </h1>
            </div>
            <div className="flex justify-end">
              <HeaderShareIcon
                className="cursor-pointer"
                style={{
                  width: "16px",
                  height: "16px",
                  gap: "0px",
                  opacity: "0px",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderTextStickyCard;
